import { render } from "./HiddenCache.vue?vue&type=template&id=52765a34"
import script from "./HiddenCache.vue?vue&type=script&lang=js"
export * from "./HiddenCache.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/buildings/HiddenCache.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "52765a34"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('52765a34', __exports__)) {
    api.reload('52765a34', __exports__)
  }
  
  module.hot.accept("./HiddenCache.vue?vue&type=template&id=52765a34", () => {
    api.rerender('52765a34', render)
  })

}


export default __exports__